import { TestKey } from "./types";

export const FCR_N_TESTS: { key: TestKey; label: string }[] = [
  { key: "energy_management", label: "Energy management" },
  { key: "step_test_high_droop", label: "Step test - high droop" },
  { key: "step_test_low_droop", label: "Step test - low droop" },
  { key: "sine_test", label: "Sine test" },
  { key: "one_hour_test", label: "1-hour test" },
];

export const FCR_D_TESTS: { key: TestKey; label: string }[] = [
  { key: "energy_management_up", label: "Energy management - up" },
  { key: "energy_management_down", label: "Energy management - down" },
  { key: "ramp_test_high_droop_up", label: "Ramp test - high droop - up" },
  { key: "ramp_test_low_droop_up", label: "Ramp test - low droop - up" },
  { key: "ramp_test_high_droop_down", label: "Ramp test - high droop - down" },
  { key: "ramp_test_low_droop_down", label: "Ramp test - low droop - down" },
  { key: "sine_test", label: "Sine test" },
  { key: "one_hour_test", label: "1-hour test" },
];

export const AFRR_TESTS: { key: TestKey; label: string }[] = [
  { key: "afrr_up", label: "AFRR up" },
  { key: "afrr_down", label: "AFRR down" },
];
